export function getFormatsTitle(ticketSelectedFormats: string[], emptyTitle = 'N/A'): string {
  if (!ticketSelectedFormats || ticketSelectedFormats?.length === 0) {
    return emptyTitle
  } else if (ticketSelectedFormats?.length <= 2) {
    return ticketSelectedFormats.join(', ')
  } else if (ticketSelectedFormats?.length > 2) {
    return `${ticketSelectedFormats.slice(0, 2).join(', ')} + ${ticketSelectedFormats.length - 2} more`
  }
}
